interface ExtractQuestionIdFromKeyParams {
	key: string
	id: string
}

export function extractQuestionIdFromKey({
	key,
	id,
}: ExtractQuestionIdFromKeyParams): string {
	if (!key) {
		return ''
	}
	const match = key.match(new RegExp(`${id}-(.+)`))
	return match && match[1] ? match[1] : ''
}
